import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import Cell from "./Cell";
import Row from "./Row";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: scroll;
`;
const Header = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  height: 40px;
  background-color: #ffffff;
  align-items: center;
  border-top: 1px solid #ecedf1;
  border-bottom: 1px solid #ecedf1;

  ${({ minWidth }) =>
    minWidth &&
    css`
      min-width: ${minWidth};
    `}
`;
const Body = styled.div`
  /* max-height: 310px; */
  ${({ contentMaxHeight }) =>
    contentMaxHeight &&
    css`
      max-height: ${contentMaxHeight};
    `}

  ${({ minWidth }) =>
    minWidth &&
    css`
      min-width: ${minWidth};
    `}
`;

function Table({ data, columns, minWidth, contentMaxHeight, ...props }) {
  return (
    <Container {...props}>
      <Header minWidth={minWidth}>
        {columns.map(({ label, width, minWidthCell, adaptive }) => (
          <Cell key={label} width={width} minWidthCell={minWidthCell} fontSize="bold" adaptive={adaptive}>
            {label}
          </Cell>
        ))}
      </Header>
      <Body minWidth={minWidth} contentMaxHeight={contentMaxHeight}>
        {data.map((row, idx) => (
          <Row key={idx} index={idx} columns={columns} row={row} />
        ))}
      </Body>
    </Container>
  );
}

Table.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  minWidth: PropTypes.string,
  contentMaxHeight: PropTypes.string,
};

export default Table;
